module.exports = __webpack_public_path__ + "static/media/moreOptions.951f5021.svg";